<template>
  <div>
    <h2>Opdracht - Start - Tekenaar</h2>
    <br>
    <span><span class="bold">Startdatum:</span><br>{{startLog.startDatum.toDate().toUTCString()}}</span>
    <br>
    <br>
    <span><span class="bold">Verwacht einddatum:</span><br>{{startLog.verwachtEindDatum.toDate().toUTCString()}}</span>
    <br>
    <br>
    <span><span class="bold">Omschrijving tekenaar:</span><br>{{startLog.korteOmschrijving}}</span>
    <br>
    <br>
    <span><span class="bold">Prijsafspraak:</span><br>{{startLog.prijsAfspraak}}</span>
    <br>
    <br>
    <span><span class="bold">prijs:</span><br>€{{startLog.prijs}}</span>
    <br>
    <br>
    <span><span class="bold">opdrachtbevestiging:</span><br>{{startLog.opdrachtBevestigingsUrl}}</span>
    <br>
    <br>
  </div>
</template>

<script>

export default {
  props: ['startLog'],
}
</script>

<style lang="sass" scoped>

.bold
  font-weight: 600

</style>